module.exports = __webpack_public_path__ + "img/img4.61704a67.jpg";